import { Injectable } from '@angular/core';
import * as models from '@daas-consulting/production/remitos/frontend/models';
import { Selector } from '@ngxs/store';
import { RemitosPrintState } from './remitos-print.state';
import { RemitosPrintStateModel } from './remitos-print.state-model';

@Injectable()
export class RemitosPrintSelectors {
  @Selector([RemitosPrintState])
  static printData(
    state: RemitosPrintStateModel
  ): models.print.PrintDataView | null {
    return state.printData;
  }
}
